import React from "react";
import styles from './Styles.module.scss';
import classNames from 'classnames';
import TextInput from "@/components/input/text/TextInput";

export default function PhoneInput({ className, placeholder, type, required, name, pattern, register, defaultValue, onChange }) {

  return (
    <TextInput
      name={name}
      register={register}
      type={type}
      placeholder={placeholder}
      pattern={pattern}
      defaultValue={defaultValue}
      required={required}
      onChange={onChange}
      className={classNames(styles.container, className)}
    />
  )
}
